'use client';

import { FC, PropsWithChildren, useEffect, useState } from 'react';
import { motion } from 'framer-motion';

const IsScrolledWrapper: FC<PropsWithChildren> = ({ children }) => {
  const [visible, setVisible] = useState<boolean>(false);

  useEffect(() => {
    const listener = () => {
      if (!visible) {
        setVisible(true);
      }
    };

    window.removeEventListener('scroll', listener);
    window.addEventListener('scroll', listener);

    if (!visible) {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 50) {
        setVisible(true);
      }
    }

    return () => {
      window.removeEventListener('scroll', listener);
    };
  }, [visible]);

  return (
    <>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          {children}
        </motion.div>
      )}
    </>
  );
};

export default IsScrolledWrapper;
